import { useRef, useState } from "react";

const sports = [
  {
    id: 1,
    title: "Final | India vs Pakistan | Asia Cup 2025",
    src: "https://www.youtube.com/embed/MAm0RLQpYas"
  },
  {
    id: 2,
    title: "India v USA | Womens World Cup 2018",
    src: "https://www.youtube.com/embed/MNTY_Vn6Tj4"
  },
  {
    id: 3,
    title: "Ronaldo Vs Messi Motorcycle Race",
    src: "https://www.youtube.com/embed/rqzxEejSKYw"
  },
  {
    id: 4,
    title: "Final Match | India vs Chinese Taipei | Kabaddi WC",
    src: "https://www.youtube.com/embed/8Xc9GkO-QTM"
  }
];

const getThumb = (url) => {
  const id = url.split("/embed/")[1];
  return `https://img.youtube.com/vi/${id}/mqdefault.jpg`;
};

export default function SportsRow() {

  const rowRef = useRef();
  const [play, setPlay] = useState(null);

  return (
    <>
      {/* FULL PLAYER */}
      {play && (
        <div className="sportsPlayer">
          <div className="sportsBack" onClick={() => setPlay(null)}>
            ❮ Back
          </div>

          <iframe
            src={play + "?autoplay=1"}
            allow="autoplay; encrypted-media"
            allowFullScreen
          />
        </div>
      )}

      {!play && (
        <div className="sportsWrap">

          <h2>Non-Stop Sports</h2>

          <div className="sportsSlider">

            <div
              className="navArrow"
              onClick={() => rowRef.current.scrollLeft -= 400}
            >❮</div>

            <div className="sportsRow" ref={rowRef}>
              {sports.map((s) => (
                <div
                  key={s.id}
                  className="sportsCard"
                  onClick={() => setPlay(s.src)}
                >
                  <img src={getThumb(s.src)} />

                  <div className="playIcon">▶</div>

                  <p>{s.title}</p>
                </div>
              ))}
            </div>

            <div
              className="navArrow"
              onClick={() => rowRef.current.scrollLeft += 400}
            >❯</div>

          </div>
        </div>
      )}

      {/* STYLE */}
      <style>{`
        .sportsWrap {
          padding: 20px 40px;
        }

        .sportsWrap h2 {
          margin-bottom: 14px;
        }

        .sportsSlider {
          position: relative;
        }

        .sportsRow {
          display: flex;
          gap: 20px;
          overflow-x: auto;
          scroll-behavior: smooth;
        }

        .sportsRow::-webkit-scrollbar {
          display: none;
        }

        .sportsCard {
          min-width: 300px;
          cursor: pointer;
          position: relative;
        }

        .sportsCard img {
          width: 100%;
          border-radius: 10px;
        }

        .sportsCard p {
          margin-top: 6px;
          font-size: 14px;
        }

        /* PLAY ICON */
        .playIcon {
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          font-size: 48px;
          background: rgba(0,0,0,0.6);
          width: 70px;
          height: 70px;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          opacity: 0;
          transition: 0.3s;
        }

        .sportsCard:hover .playIcon {
          opacity: 1;
        }

        /* ARROWS */
        .navArrow {
          position: absolute;
          top: 40%;
          font-size: 34px;
          cursor: pointer;
          z-index: 5;
          background: rgba(0,0,0,0.7);
          padding: 10px;
          border-radius: 50%;
        }

        .navArrow:first-child {
          left: -15px;
        }

        .navArrow:last-child {
          right: -15px;
        }

        /* FULL PLAYER */
        .sportsPlayer {
          position: fixed;
          inset: 0;
          background: #000;
          z-index: 9999;
        }

        .sportsPlayer iframe {
          width: 100%;
          height: 100%;
          border: none;
        }

        .sportsBack {
          position: absolute;
          top: 20px;
          left: 20px;
          z-index: 10;
          padding: 8px 16px;
          background: #fff;
          color: #000;
          font-weight: 600;
          cursor: pointer;
        }
      `}</style>
    </>
  );
}
